export enum StructuralAnalysisStatusAPIResponse {
  AsBuiltsProvided = 'asBuiltsProvided',
  SiteVisitNeeded = 'siteVisitNeeded',
  SiteVisitComplete = 'siteVisitComplete',
  PreliminaryChangesNeeded = 'preliminaryChangesNeeded',
  PreliminaryComplete = 'preliminaryComplete',
  FinalComplete = 'finalComplete',
}
